import { __awaiter, __generator } from "tslib";
var cancellableDelay = function (delay) {
    var resolvePromise;
    var timer = setTimeout(function () { return resolvePromise(); }, delay);
    var promise = new Promise(function (res) {
        resolvePromise = res;
    });
    return {
        promise: promise,
        cancel: function () {
            clearTimeout(timer);
        },
    };
};
var isPromise = function (item) {
    var i = item;
    return i && i.then && i.catch;
};
export function debounce(func, wait, onCancelFunctionAvailable) {
    var _this = this;
    var delayManager = cancellableDelay(wait);
    if (onCancelFunctionAvailable) {
        onCancelFunctionAvailable(delayManager.cancel);
    }
    var runningPromises = [];
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        delayManager.cancel();
        delayManager = cancellableDelay(wait);
        if (onCancelFunctionAvailable) {
            onCancelFunctionAvailable(delayManager.cancel);
        }
        return delayManager.promise.then(function () {
            return Promise.all(runningPromises);
        }).then(function () { return __awaiter(_this, void 0, void 0, function () {
            var result, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        result = func.apply({}, args);
                        if (!isPromise(result)) return [3 /*break*/, 5];
                        runningPromises.push(result);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, result];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 3:
                        e_1 = _a.sent();
                        return [2 /*return*/, Promise.reject(e_1)];
                    case 4:
                        // cleanup
                        runningPromises = runningPromises
                            .filter(function (p) { return p !== result; });
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/, result];
                }
            });
        }); });
    };
}
//# sourceMappingURL=index.js.map